import { userGroupsEn } from './en'

export const userGroupsEnGb = userGroupsEn
